import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const xiaoQuan = {
  id: uuidv4(),
  name: 'XIAO QUAN',
  path: '/xiao-quan',
  bios: [
    'DJ e produtor, sua pesquisa se concentra em música eletrônica marginal de diferentes lugares do globo e seu trabalho se inclina sobre a natureza de fenômenos contemporâneos ligados ao fluxo informacional da era digital. Suas paisagens sonoras dão conta de cenários caóticos em franca transformação e formam pistas avançadas e contagiantes. Frenética e constante, sua produção combina diversas referências e vertentes, sempre sob alta temperatura.',
    'DJ and producer, his research focuses on marginal electronic music from around the globe and his work leans on the nature of contemporary phenomena linked to the informational flow of the digital age. His soundscapes devise chaotic scenarios in constant transformation, and form advanced and contagious dancefloors. Frantic and constant, his production combines different references and dimensions, always under high temperature.',
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'Achados e Perdidos (Fitas Coreanas)',
      type: JobTypes.AUDIO,
      path: '/achados-e-perdidos',
      image: '/assets/xiao-quan/achado-e-perdidos.png',
      imageHover: '/assets/xiao-quan/achado-e-perdidos_hover.png',
      texts: [
        'Fitas coreanas encontradas no lixo, agora distorcidas e reprogramadas no calor dos trópicos.',
        'Korean tapes found in the trash, now distorted and reprogrammed under the heat of the tropics.',
      ],
      pages: [
        {
          id: uuidv4(),
          link: 'Mix',
          title: 'Achados e Perdidos',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Achados+e+Perdidos.wav`,
          path: '/mix',
        },
        {
          id: uuidv4(),
          link: 'B1',
          title: 'Korea Beat 1',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Korea+Beat+1.wav`,
          path: '/b1',
        },
        {
          id: uuidv4(),
          link: 'B2',
          title: 'Korea Beat 2',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Korea+Beat+2.wav`,
          path: '/b2',
        },
        {
          id: uuidv4(),
          link: 'B3',
          title: 'Korea Beat 3',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Korea+Beat+3.wav`,
          path: '/b3',
        },
        {
          id: uuidv4(),
          link: 'B4',
          title: 'Korea Beat 4',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Korea+Beat+4.wav`,
          path: '/b4',
        },
        {
          id: uuidv4(),
          link: 'B5',
          title: 'Korea Beat 5',
          src: `${STORAGE_PATH}/XIAO+QUAN/XIAO+QUAN+-+Korea+Beat+5.wav`,
          path: '/b5',
        },
      ]
    },
  ],
}

export default xiaoQuan
